import {InsurancePolicyList} from "components/Contractors/InsurancePolicy";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React from "react";

export const ContractorInsurancePolicies = ({contractor, ...columnProps}) => (
    <DetailsColumn section={{label: 'contractor.form.insurancePolicies'}} {...columnProps}>
        <InsurancePolicyList contractorId={contractor.id}/>
    </DetailsColumn>
)